import type { DeleteApiTagsIdPathParams } from '@/shared/api'
import { STRINGS } from '@/shared/config'
import { showNotificationSuccessFx } from '@/shared/lib/providers'
import { createEvent, sample } from 'effector'

import { tagCreate, tagDelete, tagUpdate } from '../api'

sample({
  clock: tagCreate.finished.success,
  fn: () => ({ message: STRINGS.success_creation }),
  target: showNotificationSuccessFx,
})

sample({
  clock: tagUpdate.finished.success,
  fn: () => ({ message: STRINGS.success_update }),
  target: showNotificationSuccessFx,
})

export const tagDeleted = createEvent<{
  id: DeleteApiTagsIdPathParams['Id']
}>()

sample({
  clock: tagDeleted,
  fn: ({ id }) => ({ id }),
  target: [tagDelete.start],
})

sample({
  clock: tagDelete.finished.success,
  fn: () => ({ message: STRINGS.success_deletion }),
  target: showNotificationSuccessFx,
})
